import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormInputField } from './form-input.model';
import { FormControl } from '@angular/forms';
import { FormFieldService } from '../../services/form-field.service';
import { Observable } from 'rxjs';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInputComponent<N = any> extends FormBaseComponent<FormInputField<N>> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  isFormatedValue = false;
  displayValue: string;

  control: FormControl = new FormControl();

  currencyOptions = {
    prefix: 'R$ ',
    thousands: '.',
    decimal: ',',
    precision: 2
  };

  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    if (this.field.inputType === 'date') {
      this.isFormatedValue = true;
    }

    if (this.field.inputType == 'value') {
      if (!this.field.value) {
        this.setControlValue('N/D');
      } else if (typeof this.field.value == 'string') {
        this.setControlValue(this.field.value);
      } else if (this.field.value instanceof Observable) {
        this.subscribe = this.field.value.subscribe(value => this.setControlValue(value));
      } else {
        this.setControlValue('N/D');
      }
    }
  }

  onComponentDestroy() { }

  setControlValue(value: any) {
    const pv: any = {};
    pv[this.field.name] = value;
    this.group.patchValue(pv);
  }

  selectOnFocus($event: FocusEvent) {
    const inp: HTMLInputElement = $event.target as HTMLInputElement;
    inp.select();
  }

  prefixClick() {
    if (this.field.prefix) {
      if (this.field.prefix.action) {
        this.field.prefix.action(this.service)
      }
    }
  }

  suffixClick() {
    if (this.field.suffix) {
      if (this.field.suffix.action) {
        this.field.suffix.action(this.service)
      }
    }
  }

}
